'use client';
import { useShareResult } from '@/lib/gameShare';

/* Share text mirrors SPOT + Connections: the emoji grid, an optional streak
   line, and the dated namethecar.com/<date> deep link. That short link 301s to
   /play/<date>, which day-aware-resolves the calendar date back to the right
   game (Decode on Thursdays & Sundays) — so the share URL format stays identical across
   games. The grid's own header carries "DECODE #NNN  N/9". */
export function DecodeShareButton({
  grid,
  date,
  streak,
}: {
  grid: string;
  date: string;
  streak?: number;
}) {
  const lines = [grid];
  if (streak && streak >= 2) lines.push(`🔥 ${streak}-day streak`);
  lines.push(`https://namethecar.com/${date}`);
  const { share, copied } = useShareResult('decode', lines.join('\n'));
  return (
    <button
      type="button"
      onClick={share}
      style={{
        padding: '10px 18px',
        borderRadius: 10,
        border: 'none',
        cursor: 'pointer',
        background: 'var(--apex-deep, #b3433a)',
        color: '#fff',
        fontWeight: 600,
      }}
    >
      {copied ? 'Copied!' : 'Share result'}
    </button>
  );
}
